// extracted by mini-css-extract-plugin
export default {"root":"AutoTemplateRoute_root__YWXlN","content":"AutoTemplateRoute_content__SjgFS"};